import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

import Navbar from "./components/NavBar/NavBar.jsx";
import PermissionRoute from "./components/PermissionRoutes/PermissionRoutes";

import Home from "./pages/Home/Home";
import Login from "./pages/Login/Login";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import AllTablePage from "./pages/AllTablePage/AllTablePage.jsx";
import AllEditPage from "./pages/AllEditPage/AllEditPage.jsx";
import AllFormPage from "./pages/AllFormPage/AllFormPage.jsx";
import ProjectDashboard from "./pages/ProjectDashboard/ProjectDashboard.jsx";
import About from "./pages/About/About";
import Dashboard from "./pages/Dashboard/Dashboard";
import Settings from "./pages/Settings/Settings";

import { getAppConfig } from "./utils/config.js";
// import UAUCCommandCenter from "./components/UaucAnalytics/UaucAnalytics.js";

const { companyName, appName, logo } = getAppConfig();

// ✅ Layout that always shows Navbar for private routes
const PrivateLayout = ({ children }) => (
  <>
    <Navbar logo={logo} appName={appName} companyName={companyName} />
    <main>{children}</main>
  </>
);

const App = () => {
  const privateRoutes = [
    { path: "/", component: <Home /> },
    { path: "/project-dashboard", component: <ProjectDashboard /> },
    {
      path: "/table/:model",
      permission: "table:view",
      component: <AllTablePage />,
    },
    {
      path: "/edit/:model/:id",
      permission: "table:view",
      component: <AllEditPage />,
    },
    {
      path: "/form/:model",
      permission: "table:view",
      component: <AllFormPage />,
    },
    {
      path: "/dashboard",
      permission: "dashboard:view",
      component: <Dashboard />,
    },
    { path: "/settings", permission: "settings:view", component: <Settings /> },
    // { path: "/uaucdata", permission: "settings:view", component: <UAUCCommandCenter apiUrl="https://jkumarapi.axiomos.in/uauc"/>},
    { path: "/about", permission: "about:view", component: <About /> },
  ];

  // 🔄 Update document branding on mount
  useEffect(() => {
    if (appName) document.title = appName;
    if (logo) {
      const favicon = document.getElementById("favicon");
      if (favicon) favicon.href = logo;
    }
  }, []);

  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} />
      <Routes>
        {/* 🔓 Public Routes */}
        <Route
          path="/login"
          element={
            <PermissionRoute isPublic>
              <Login />
            </PermissionRoute>
          }
        />
        <Route
          path="/reset-password"
          element={
            <PermissionRoute isPublic>
              <ResetPassword />
            </PermissionRoute>
          }
        />

        {/* 🔐 Private Routes (wrapped in layout) */}
        {privateRoutes.map(({ path, component, permission }) => (
          <Route
            key={path}
            path={path}
            element={
              <PermissionRoute permission={permission}>
                <PrivateLayout>{component}</PrivateLayout>
              </PermissionRoute>
            }
          />
        ))}
      </Routes>
    </Router>
  );
};

export default App;
